import { useAuthStore } from '@/stores/auth'

// v-can="'permission'": removes the element when the current user lacks the permission.
export default {
    mounted(el, binding) {
        const auth = useAuthStore()
        if (!auth.isAuthenticated || !auth.user.can(binding.value)) {
            el.remove()
        }
    },
}
